import { Button } from "components/common/buttons/Button";
import { GoogleMapsAutocompleteInput } from "components/common/input/GoogleMapsAutocompleteInput";
import FormGroupLabel from "components/common/text/FormGroupLabel";
import type { ProductionBaseFieldProps } from "./ProductionBaseField.types";

export const ProductionBaseField = ({
  value,
  onChange,
  disabled = false,
  taxState,
  onViewTaxIncentives,
  showRequiredMarker = false,
  showLabel = true,
  helperText,
}: ProductionBaseFieldProps) => {
  return (
    <div className="flex flex-col gap-2">
      {showLabel ? (
        <FormGroupLabel marginBottom={false}>
          Production base
          {showRequiredMarker ? <span className="text-primary"> *</span> : null}
        </FormGroupLabel>
      ) : null}
      <GoogleMapsAutocompleteInput
        name="production_base"
        placeholder="Search for a city or region"
        value={value}
        onChange={onChange}
        disabled={disabled}
        showUnavailableHint
      />
      {taxState ? (
        <p className="text-xs text-muted-foreground">
          Tax state: {taxState}
          {onViewTaxIncentives ? (
            <>
              {" · "}
              <Button
                type="button"
                color="gray"
                size="xs"
                className="h-6 px-2"
                onClick={() => onViewTaxIncentives(taxState)}
              >
                view tax incentives
              </Button>
            </>
          ) : null}
        </p>
      ) : null}
      {helperText ? <p className="text-xs text-muted-foreground">{helperText}</p> : null}
    </div>
  );
};
